import React from 'react';
import { Pressable as RNPressable } from 'react-native';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useNavPressableLink from './useNavPressable';
import usePressFeedback from './usePressFeedback';
const PressableInteractive = React.forwardRef(({ touchFeedback = true, style, disabled, resolvedOnPress, href, accessibilityRole, onLayout, children, to: _to, ...pressableProps }, ref) => {
    const [{}] = useTheme(stylesGenerator);
    const isInteractive = !!(resolvedOnPress || href) && !disabled;
    const feedback = usePressFeedback({
        touchFeedback,
        style,
        disabled,
        isInteractive,
        hasHref: !!href,
        onLayout,
    });
    if (!isInteractive) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(RNPressable, { ref: ref, onPress: resolvedOnPress, href: href, accessibilityRole: accessibilityRole, hitSlop: feedback.hitSlop, onLayout: feedback.onLayout, style: feedback.resolvedStyle, disabled: disabled, ...feedback.pressHandlers, ...pressableProps }, children));
});
const PressableWithNav = React.forwardRef(({ to, onPress, disabled, ...rest }, ref) => {
    const link = useNavPressableLink({ to, onPress, disabled });
    return (React.createElement(PressableInteractive, { ref: ref, disabled: disabled, resolvedOnPress: link.onPress, href: link.href, accessibilityRole: link.accessibilityRole, ...rest }));
});
const Pressable = React.forwardRef((props, ref) => {
    const { to, onPress, ...rest } = props;
    if (to) {
        return (React.createElement(PressableWithNav, { ref: ref, to: to, onPress: onPress, ...rest }));
    }
    return (React.createElement(PressableInteractive, { ref: ref, onPress: onPress, resolvedOnPress: onPress, ...rest }));
});
Pressable.displayName = 'Pressable';
const stylesGenerator = createThemedStyle(({}) => ({}));
export default Pressable;
